import { booleanAttribute, Component, computed, input, output } from "@angular/core";

import { entryAccessibleName } from "../timeline-layout";
import { TimelineEntry } from "../timeline.model";

/** One-day entry: color dot (plus the red triangle when its date is part of a mismatch), label and context. */
@Component({
  selector: "lib-timeline-chip",
  template: `
    <button
      type="button"
      class="chip"
      [class.chip-tint]="entry().tint"
      [style.--entry-color]="entry().color"
      [class.chip-touch]="touch()"
      [class.is-selected]="selected()"
      [attr.aria-label]="accessibleName()"
      [attr.aria-pressed]="selected()"
      [title]="accessibleName()"
      (click)="selectEntry.emit(entry().id)"
    >
      <span
        class="marks"
        aria-hidden="true"
      >
        <span class="dot"></span>
        @if (entry().warn) {
          <svg
            class="warn"
            [class.caution]="entry().warn === 'warning'"
            viewBox="0 0 24 24"
          >
            <path d="M12 2 1 21h22L12 2zm1 15h-2v-2h2v2zm0-4h-2V9h2v4z" />
          </svg>
        }
      </span>
      @if (!compact()) {
        <span
          class="body"
          aria-hidden="true"
        >
          <span class="label">{{ entry().label }}</span>
          <span class="context">{{ entry().context }}</span>
        </span>
      } @else {
        <span
          class="label"
          aria-hidden="true"
          >{{ text() ?? entry().label }}</span
        >
      }
    </button>
  `,
  styleUrl: "./timeline-chip.component.scss",
})
export class TimelineChip {
  readonly entry = input.required<TimelineEntry>();
  readonly selected = input(false);
  /** One line, no context (tablet Gantt). */
  readonly compact = input(false);
  /** One-line text in place of the label, e.g. a short label with its date on the Gantt's week scale. */
  readonly text = input<string>();
  /** 44px tall for the phone agenda. */
  readonly touch = input(false, { transform: booleanAttribute });
  readonly selectEntry = output<string>();

  protected readonly accessibleName = computed(() => entryAccessibleName(this.entry()));
}
